import * as Flags from "country-flag-icons/react/3x2";
import { Globe } from "lucide-react";

import { buscarPais } from "../../helpers/paises";
import { cn } from "../../lib/utils";

// Bandeira do país, em SVG.
//
// Não é emoji: no Windows a fonte do sistema não tem os glifos de bandeira e
// "🇵🇹" aparece como as letras "PT". Metade da equipe veria dois caracteres
// soltos no lugar do que a tela promete.
//
// País desconhecido (ou número que não dá para atribuir a lugar nenhum) mostra
// o globo — melhor do que a bandeira errada.

const Bandeira = ({ codigo, className, title }) => {
	const pais = buscarPais(codigo);
	const Svg = pais ? Flags[pais.codigo] : null;

	const legenda = title || pais?.nome || "País não identificado";

	if (!Svg) {
		return (
			<Globe
				aria-label={legenda}
				className={cn("h-3.5 w-5 text-muted-foreground", className)}
			/>
		);
	}

	return (
		<Svg
			aria-label={legenda}
			title={legenda}
			className={cn(
				"h-3.5 w-5 shrink-0 rounded-[2px] object-cover ring-1 ring-border/60",
				className,
			)}
		/>
	);
};

export default Bandeira;
